import React from "react";
import PropTypes from "prop-types";
import { Tabs } from "@opendate-app/setlist";

export const TAB_PRODUCTS = "products";
export const TAB_CARDS = "cards";
export const TAB_REDEEM = "redeem";

const GiftCardTabs = ({ current, productsPath, cardsPath, redeemPath }) => {
  const paths = { [TAB_PRODUCTS]: productsPath, [TAB_CARDS]: cardsPath, [TAB_REDEEM]: redeemPath };
  const items = [
    productsPath && { value: TAB_PRODUCTS, label: "Products" },
    cardsPath && { value: TAB_CARDS, label: "Gift cards" },
    redeemPath && { value: TAB_REDEEM, label: "Redeem" },
  ].filter(Boolean);

  if (items.length < 2) return null;

  return (
    <div className="gift-card-tabs">
      <Tabs
        items={items}
        value={current}
        onChange={(value) => {
          if (value !== current) window.location.href = paths[value];
        }}
      />
    </div>
  );
};

GiftCardTabs.propTypes = {
  current: PropTypes.oneOf([TAB_PRODUCTS, TAB_CARDS, TAB_REDEEM]).isRequired,
  productsPath: PropTypes.string,
  cardsPath: PropTypes.string,
  redeemPath: PropTypes.string,
};

GiftCardTabs.defaultProps = {
  productsPath: null,
  cardsPath: null,
  redeemPath: null,
};

export default GiftCardTabs;
